<template>
  <div>
    <el-card style="width: 80%;margin: 20px auto;">
      关键字：
      <el-input style="width: 15%;margin-right: 2%" type="text" placeholder="用户名称/手机号码/客户号" v-model="allName" />
      <el-button icon="el-icon-search" type="success" @click="handleCurrentChange">搜索</el-button>
    </el-card>
    <el-table :data="users" class="tb-edit" style="width: 80%;margin: 20px auto;">
      <el-table-column label="序号" min-width="12%">
        <template slot-scope="scope">
          <el-button type="text" @click="rowClick(scope.row)">{{scope.$index + 1}}</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="tu_username" label="客户名称" min-width="24%">
      </el-table-column>
      <el-table-column prop="tu_phone" label="客户电话" min-width="24%">
      </el-table-column>
      <el-table-column prop="tu_account" label="客户号" min-width="24%">
      </el-table-column>
      <el-table-column label="下单时间" min-width="24%">
        <template slot-scope="scope">
          <p v-if="scope.row.tu_date == null"></p>
          <p v-else>{{scope.row.tu_date | moment}}</p>
        </template>
      </el-table-column>

    </el-table>
    <div style="text-align: center;margin-top: 20px;">
      <!--分页组件-->
      <el-pagination @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize" layout="total, prev, pager, next, jumper"
        :total="total"></el-pagination>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        users: [],
        allName: '',
        currentPage: 1,
        pageSize: 24,
        total: 0,
        page: 1

      }
    },
    mounted() {
      this.handleCurrentChange();
    },
    methods: {
      getTotal() {
        this.$inbound.post({
          interfaceId: 'user/getTotal',
          data: {
            allName: this.allName
          }
        }).then(response => {
          this.total = response
        }).catch(error => {
          console.log(error)
        })
      },
      //获取用户信息
      handleCurrentChange(val) {

        this.getTotal()

        if (isNaN(val)) {
          console.log("Hello world")
          this.currentPage = 1
        } else {
          this.currentPage = val
          console.log("val ==", val)
        }


        this.$inbound.post({
          interfaceId: 'user/selectAppAll',
          data: {
            allName: this.allName,
            page: this.currentPage
          }
        }).then(response => {
          console.log(response)
          this.users = response
        }).catch(error => {
          console.log(error)
        })
      }
    }
  }
</script>

<style scoped>

</style>
